// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper{box-sizing:border-box;margin:.729vw auto;height:calc(100vh - 7.917vw);overflow:auto;border-radius:.625vw;overflow:hidden;min-width:62.5vw}", ""]);
// Exports
module.exports = exports;
